import PostsAdapter from '../base';

export default class Page extends PostsAdapter {
  modelNamePlural = 'pages';
}
